import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'
import type { UseFiltersPayload } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ManageActivityModal from '@modals/ManageActivityModal'

import type { ActivityModel } from '@models/types'

import PageContent from './components/PageContent'

type DefaultState = {
  showManageActivityModal: boolean,
}

const defaultState = {
  showManageActivityModal: false,
}

type SetState = (state: Partial<DefaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManageActivityModal: {
      closeModal: () => setState({ showManageActivityModal: false }),
    },
  }

  return componentCallbacks[component] || {}
}

const ActivityLogs = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showManageActivityModal,
  } = state

  const filtersPayload = useFilters()
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload

  const modalContext = useModals()
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showManageActivityModal: (payload: ActivityModel) => {
        setModalData('ManageActivityModal', payload)
        setState({ showManageActivityModal: true })
      },
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        {/*
        // @ts-expect-error TS2739 */}
        <PageContent pageFilters={pageFilters} />

        <ManageActivityModal
          callbacks={callbacks('ManageActivityModal', setState)}
          showModal={showManageActivityModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export type PageContextPayload = UseFiltersPayload

export default ActivityLogs
